
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cinemas",
      function () {
        return require("private-next-pages/cinemas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cinemas"])
      });
    }
  